








import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "uc-menu-sub"
})
export default class UcMenuSubComponent extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  show: Boolean;

  isShow = this.show;
  
}
